<p-toast></p-toast>

<div class="dispute-review-page">
    <div class="sticky-toolbar mb-8 text-[14px]">
        <p-toolbar class="text-[14px] p-0">
            <ng-template pTemplate="start">
                <div class="left-buttons">
                    <h5 class="dispute-toolbar-title">Dispute Review</h5>
                    <p-button
                        label="Refresh"
                        icon="pi pi-refresh"
                        severity="secondary"
                        (onClick)="reload()"
                    ></p-button>
                </div>
            </ng-template>
            <ng-template pTemplate="end">
                <div class="right-buttons">
                    <p-button
                        label="Back to Orders"
                        icon="pi pi-arrow-left"
                        severity="secondary"
                        [routerLink]="['/Orders1']"
                    ></p-button>
                </div>
            </ng-template>
        </p-toolbar>
    </div>

    <app-dispute-kpi-bar
        [stats]="kpiStats"
        [activeFilter]="selectedStatus"
        (filterSelect)="onKpiFilterSelect($event)"
    ></app-dispute-kpi-bar>

    <div class="filters-row">
        <div class="date-range-filter">
            <label class="date-label" for="disputeFromDate">From</label>
            <input
                id="disputeFromDate"
                type="date"
                pInputText
                class="date-input"
                [(ngModel)]="fromDate"
                [max]="toDate"
                (change)="onDateChange()"
            />
            <label class="date-label" for="disputeToDate">To</label>
            <input
                id="disputeToDate"
                type="date"
                pInputText
                class="date-input"
                [(ngModel)]="toDate"
                [min]="fromDate"
                (change)="onDateChange()"
            />
        </div>
        <span class="search-wrap">
            <i class="pi pi-search"></i>
            <input
                pInputText
                type="search"
                placeholder="Search claim / order / customer"
                [(ngModel)]="searchQuery"
                (ngModelChange)="onSearchChange()"
            />
        </span>
        <p-select
            [options]="statusOptions"
            [(ngModel)]="selectedStatus"
            optionLabel="label"
            optionValue="value"
            placeholder="Filter"
            (onChange)="onFilterChange()"
        ></p-select>
    </div>

    <section class="list-section">
        <app-dispute-claims-table [disputes]="filteredDisputes" (view)="openClaim($event)"></app-dispute-claims-table>
    </section>
</div>
